export default {
	hu: {
		welcomeTitle: 'Összefoglaló táblák (STADAT)',
		loadingData: 'Adatok betöltése folyamatban van, kérjük várjon.',

		// TOC Filtering
		filterTitle: 'Szűrés az alábbi táblajegyzékben',
    filterAllFreq: "Összes időszak",
    filterAnnual: "Éves táblák",
    filterInfraAnnual: "Évközi táblák",
    filterAllTerritory: "Összes területi szint",
    filterNational: "Országos táblák",
    filterRegional: "Területi táblák",
    filterInternational: "Nemzetközi táblák",
    filterAllStatus: "Összes állapot",
    filterActive: "Aktív táblák",
		filterArchived: "Archív táblák",

		// TOC List
		correctedAt: 'Hibajavítás:',
		updatedAt: 'Frissítve:',
		nextUpdate: 'Következő frissítés:',
		noTablesToShow: 'Ebben a nézetben nincsenek megjeleníthető táblák.',
		moreLinks: 'Kapcsolódó hivatkozások',
		morePenzugyiSzamlak: 'Pénzügyi számlák (mnb.hu)',

		// Search
		searchTitle: 'Keresés az Összefoglaló táblákban',
    searchInStadat: 'keresés az Összefoglaló táblákban...',
		loadingSearch: 'Keresési találatok betöltése, kérjük várjon.',
		nothingFound: 'A keresés nem talált eredményt.',
		numFound: 'Találatok száma: ',
		prevPage: 'Előző',
		nextPage: 'Következő',

		tema: {
			ara: '1. Árak',
			bel: '2. Belkereskedelem',
			ber: '3. Beruházás',
			ege: '4. Egészségügy, baleset',
			ele: '5. Életkörülmények',
			ene: '6. Energiagazdálkodás',
			epi: '7. Építőipar',
			fol: '8. Földrajzi helyzet, településszerkezet',
			gsz: '9. Gazdasági és nonprofit szervezetek',
			ido: '10. Időfelhasználás, időmérleg',
			iga: '11. Igazságszolgáltatás',
			ikt: '12. Információ, kommunikáció',
			ipa: '13. Ipar',
			jov: '14. Jövedelem és fogyasztás',
			//krm: '15. Kormányzati pénzügyek',
			kor: '15. Környezet, kommunális ellátás',
			ksp: '16. Kultúra, sport',
			kkr: '17. Külkereskedelem és fizetési mérleg',
			lak: '18. Lakás',
			mez: '19. Mezőgazdaság',
			mun: '20. Munkaerő',
			gdp: '21. Nemzeti számlák, GDP',
			nep: '22. Népesség és népmozgalom',
			okt: '23. Oktatás',
			sza: '24. Szállítás, közlekedés',
			szo: '25. Szociális ellátás',
			tte: '26. Tudomány és technológia',
			tur: '27. Turizmus, vendéglátás',
		},
		idoszak: {
			1: 'Éves adatok',
			2: 'Évközi adatok',
			8: 'Archív éves adatok',
			9: 'Archív évközi adatok',
		},
		terulet: {
			1: 'Országos adatok',
			2: 'Területi adatok',
			3: 'Nemzetközi adatok',
		},

		// First releases page
		relatedFirstReleaseItem: '%AAz-title% „%title%” című gyorstájékoztatóhoz kapcsolódó táblák.',
		firstReleaseTOCTitle: '%AAz-title% „%title%” gyorstájékoztatóhoz kapcsolódó STADAT-táblák',
		firstReleases: {
			nep: 'Népmozgalom',
			fog: 'Foglalkoztatottság',
			mun: 'Munkanélküliség',
			ker: 'Keresetek',
			lak: 'Lakásépítések, építési engedélyek',
			gde: 'Bruttó hazai termék (GDP) (első becslés)',
			gdp: 'Bruttó hazai termék (GDP) (második becslés)',
			ber: 'Beruházás',
			kue: 'Külkereskedelmi termékforgalom (első becslés)',
			kul: 'Külkereskedelmi termékforgalom (második becslés)',
			szk: 'Szolgáltatások külkereskedelmi forgalma',
			far: 'Fogyasztói árak',
			krm: 'A kormányzati szektor egyenlege',
			mgt: 'A mezőgazdaság teljesítménye',
			ipe: 'Ipar (első becslés)',
			ipa: 'Ipar (második becslés)',
			tar: 'Ipari termelői árak',
			epi: 'Építőipar',
			kis: 'Kiskereskedelem',
			ksz: 'Kereskedelmi szálláshelyek forgalma',
		},
	},
	en: {
		welcomeTitle: 'Summary Tables (STADAT)',
		loadingData: 'Loading data, please wait a moment.',

		// TOC Filtering
		filterTitle: 'Filter in the table of contents below',
    filterAllFreq: "All frequencies",
    filterAnnual: "Annual tables",
    filterInfraAnnual: "Infra-annual tables",
    filterAllTerritory: "All territorial levels",
    filterNational: "National tables",
    filterRegional: "Regional tables",
    filterInternational: "International tables",
    filterAllStatus: "All status",
    filterActive: "Active tables",
		filterArchived: "Archived tables",

		// TOC List
		correctedAt: 'Correction:',
		updatedAt: 'Updated:',
		nextUpdate: 'Next update:',
		noTablesToShow: 'No tables to display in this view.',
		moreLinks: 'Related links',
		morePenzugyiSzamlak: 'Financial accounts (mnb.hu)',

		// Search
		searchTitle: 'Search in Summary Tables',
    searchInStadat: 'search in Summary Tables...',
		loadingSearch: 'Loading search results, please wait a moment.',
		nothingFound: 'Your search did not return any results.',
		numFound: 'Number of hits: ',
		prevPage: 'Previous',
		nextPage: 'Next',

		tema: {
			ara: '1. Prices',
			bel: '2. Internal trade',
			ber: '3. Investment',
			ege: '4. Health care, accidents',
			ele: '5. Living conditions',
			ene: '6. Energy',
			epi: '7. Construction',
			fol: '8. Geographical location, settlement structure',
			gsz: '9. Business units and non-profit organisations',
			ido: '10. Time use',
			iga: '11. Justice',
			ikt: '12. Information, communication',
			ipa: '13. Industry',
			jov: '14. Income and consumption',
			//krm: '15. Kormányzati pénzügyek',
			kor: '15. Environment, public utilities',
			ksp: '16. Culture, sports',
			kkr: '17. External trade and balance of payments',
			lak: '18. Housing',
			mez: '19. Agriculture',
			mun: '20. Labour',
			gdp: '21. National accounts, GDP',
			nep: '22. Population and vital events',
			okt: '23. Education',
			sza: '24. Transport',
			szo: '25. Social care protection',
			tte: '26. Science and technology',
			tur: '27. Tourism, catering',
		},
		idoszak: {
			1: 'Annual',
			2: 'Infra-annual',
			8: 'Archived annual',
			9: 'Archived infra-annual',
		},
		terulet: {
			1: 'National',
			2: 'Regional',
			3: 'International',
		},

		// First releases page
		relatedFirstReleaseItem: 'Tables related to the first release „%title%”.',
		firstReleaseTOCTitle: 'Tables related to the first release „%title%”',
		firstReleases: {
			nep: 'Vital events',
			fog: 'Employment',
			mun: 'Unemployment',
			ker: 'Earnings',
			lak: 'Dwelling construction, construction permits',
			gde: 'Gross domestic product (GDP) (flash estimage)',
			gdp: 'Gross domestic product (GDP) (second estimate)',
			ber: 'Investment',
			kue: 'External trade in goods (first estimate)',
			kul: 'External trade in goods (second estimate)',
			szk: 'External trade in services',
			far: 'Consumer prices',
			krm: 'Balance of general government sector',
			mgt: 'Performance of agriculture',
			ipe: 'Industry (first estimate)',
			ipa: 'Industry (second estimate)',
			tar: 'Industrial producer prices',
			epi: 'Construction',
			kis: 'Retail trade',
			ksz: 'Commercial accommodation establishments',
		},
	}
};
